import React from 'react'
import { ButtonProps, useMediaQuery, useTheme } from '@mui/material'
import ActionButton from './Action.button'


// This component is optimized for responsive layouts
// Intended for use with buttons having icons and text
const ResponsiveIconButton: React.FC<ButtonProps> = ({ 
  children, 
  startIcon, 
  endIcon,
  sx,
  ...props 
}) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  
  return (
    <ActionButton
    {...props} 
      startIcon={downMd ? undefined : startIcon}
      endIcon={downMd ? undefined : endIcon}
      sx={{
        '& .MuiSvgIcon-root': {
          fontSize: downSm ? '1rem' : '1.25rem'
        },
        // hide text under 900 px
        ...(downMd && {
          minWidth: 'auto',
          paddingX: '16px',
          paddingY: '10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }),
        ...sx,
      }}
    >
      {downMd 
        ? (startIcon || endIcon) 
        : children                
      }
    </ActionButton>
  )
}

export default ResponsiveIconButton